export default __webpack_public_path__ + "static/media/copy.cb6ec96a.svg";